import {
    STORE_REPLACE_BANKS,
    STORE_RESET_BANKS,
} from '@perpay-web/fintech/constants/actionTypes';

// from the BankAccount backend model:
// https://github.com/Perpay/perpay/blob/0bfb745d38f3ef1c9338cc33694f2f2b7305916e/docker/web/app/perpay/core/models/__init__.py#L1379:L1379
export enum BANK_ACCOUNT_STATUS {
    VALID = 'valid',
    PENDING_VERIFICATION = 'pending_verification',
}

export type BankAccount = {
    uuid: string;
    status: BANK_ACCOUNT_STATUS;
    bankName: string;
    account: string;
    routing: string;
    isPrimary: boolean;
};

type BanksState = { [key: string]: BankAccount };

const initialState: BanksState = {};

const bankReducer = (
    state: BanksState = initialState,
    action: {
        type: string;
        payload: { [key: string]: BankAccount };
    },
): BanksState => {
    const { type, payload } = action;

    switch (type) {
        case STORE_REPLACE_BANKS:
            return { ...payload };
        case STORE_RESET_BANKS:
            return initialState;
        default:
            return state;
    }
};

export default bankReducer;
